<template>
  <div class="app-right-main">
    <el-row :gutter="20" class="searchRow">
      <el-col :span="22">
        <!-- 查询框区域 -->
        <el-form
          :model="searchForm"
          size="mini"
          :inline="true"
          label-width="90px"
        >
          <el-form-item label="选择设备">
            <el-select
              v-model="searchForm.devId"
              placeholder="请选择"
              clearable
              style="width: 12vw"
            >
              <el-option
                v-for="item in list"
                :key="item._id"
                :label="`${item.device_name}（${item.name}）`"
                :value="item._id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="有无项目">
            <el-select
              v-model="searchForm.hasProject"
              placeholder="请选择"
              style="width: 12vw"
            >
              <el-option label="全部" :value="0"></el-option>
              <el-option label="有" :value="1"></el-option>
              <el-option label="无" :value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>

      <!-- 提交按钮 -->
      <el-col :span="2" class="searchbuttons">
        <div>
          <el-button
            type="primary"
            size="mini"
            icon="el-icon-search"
            @click="filterData"
            >查询</el-button
          >
        </div>
        <div class="searchButton">
          <el-button
            type="info"
            size="mini"
            icon="el-icon-refresh-right"
            @click="reset"
            >重置</el-button
          >
        </div>
      </el-col>
    </el-row>
    <el-row style="margin-bottom: 20px">
      <el-col :span="12">
        <!-- <el-button
          type="primary"
          icon="el-icon-plus"
          size="small"
          @click="() => {}"
          v-if="addDev"
          >新增设备</el-button
        > -->
      </el-col>
      <el-col :span="24" style="text-align: right">
        <el-tooltip content="表格" v-if="!isTable">
          <el-button
            size="small"
            icon="el-icon-s-fold"
            @click="
              () => {
                isTable = true;
              }
            "
          ></el-button>
        </el-tooltip>
        <el-tooltip content="卡片" v-if="isTable">
          <el-button
            size="small"
            icon="el-icon-s-grid"
            @click="
              () => {
                isTable = false;
              }
            "
          ></el-button>
        </el-tooltip>
      </el-col>
    </el-row>

    <el-table v-if="isTable" :data="tbList" size="small" style="width: 100%">
      <el-table-column align="left" prop="device_name" label="设备名称">
        <template slot-scope="scope">
          <div>
            {{ scope.row.device_name }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        align="left"
        prop="name"
        label="设备型号"
      ></el-table-column>
      <el-table-column
        align="left"
        prop="updateTime"
        label="更新时间"
      ></el-table-column>
      <el-table-column
        v-if="$jumpPerm('ota_detail')"
        align="center"
        fixed="right"
        label="操作"
        width="120"
      >
        <template slot-scope="scope">
          <el-button @click="onDetail(scope.row)" type="text" size="small">
            详情
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row v-if="!isTable" :gutter="20">
      <el-col
        :span="6"
        v-for="item in tbList"
        :key="item._id"
        style="margin-bottom: 20px"
        ><el-card style="position: relative; padding-bottom: 42px">
          <h3
            style="
              height: 22px;
              width: 100%;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              margin-bottom: 5px;
            "
            :title="`${item.device_name}（${item.name}）`"
          >
            <span>{{ item.device_name }}（{{ item.name }}）</span>
          </h3>
          <div
            style="
              color: #aaa;
              font-size: 12px;
              height: 22px;
              width: 100%;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              margin-bottom: 5px;
            "
          >
            更新时间：{{ item.updateTime }}
          </div>
          <div
            style="
              width: 100%;
              text-align: center;
              overflow: hidden;
              height: 200px;
            "
            @click="onDetail(item)"
          >
            <device-image
              :name="item.name"
              :width="200"
              :height="200"
            ></device-image>
          </div>
          <div
            v-if="$jumpPerm('ota_detail')"
            style="
              height: 38px;
              position: absolute;
              left: 0;
              right: 0;
              bottom: 0;
              text-align: center;
              border-top: 1px solid #ddd;
            "
          >
            <el-button type="text" class="button" @click="onDetail(item)">
              <span style="color: #aaa"
                ><i class="el-icon-edit"></i>固件详情</span
              ></el-button
            >
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { optionsList } from "../../api/optionsApi";
import { getProjectList } from "../../api/projectApi";
import DeviceImage from "./../deviceImage";
import { handleResponse } from "../../utils/response";
export default {
  name: "OTA",
  components: { DeviceImage },
  data() {
    return {
      searchForm: {
        devId: "",
        hasProject: 1,
      },
      isTable: false,
      list: [],
      tbList: [],
    };
  },
  computed: {
    addDev() {
      return (
        this.$store.state.userInfo.permissions.includes("addDev") ||
        this.$store.getters.isAdmin
      );
    },
  },
  created() {
    this.init();
  },
  methods: {
    onDetail(item) {
      if (this.$jumpPerm("ota_detail")) {
        this.$router.push({ path: "/project", query: { id: item._id } });
      }
    },
    init() {
      optionsList({ type: 1 }).then((res) => {
        handleResponse(
          res,
          (data) => {
            getProjectList(1, 1000).then((res) =>
              handleResponse(
                res,
                (d) => {
                  const m = {};
                  d.list.forEach((p) => {
                    m[p.deviceName] =
                      p.last_modify_time > (m[p.deviceName] || "")
                        ? p.last_modify_time
                        : m[p.deviceName];
                  });
                  this.list = data.list.map((d) => {
                    return { ...d, updateTime: m[d.name] };
                  });
                  this.filterData();
                  // this.tbList = [...this.list];
                },
                (err) => {}
              )
            );
          },
          (error) => {}
        );
      });
    },

    filterData() {
      this.tbList = this.list.filter((s) => {
        const { devId, hasProject } = this.searchForm;
        return (
          (!devId || s._id === devId) &&
          (!hasProject ||
            (hasProject === 1 && s.updateTime) ||
            (hasProject === 2 && !s.updateTime))
        );
      });
    },
    reset() {
      this.searchForm = { devId: "", hasProject: 1 };
      this.filterData();
    },
  },
};
</script>
<style scoped></style>
